import { ProgramContent } from '@cibo/core'
import { Grid, Stack, Typography } from '@mui/material'

export const ValueProps = ({ program }: { program: { fields: ProgramContent } }) => {
  if (program.fields.valueProps === undefined) return null

  const { valueProps } = program.fields

  return (
    <Grid container spacing={8}>
      {valueProps.map(({ fields: { body, title } }, index) => {
        return (
          <Grid item xs={12} md={12 / valueProps.length} key={index}>
            <Stack spacing={2}>
              <Typography color="text.secondary" variant="h5" align="left">
                {title}
              </Typography>
              <Typography color="text.primary">{body}</Typography>
            </Stack>
          </Grid>
        )
      })}
    </Grid>
  )
}
